import template from './trip-item-cancellation-message.html';
import CANCEL_ITEM_STATUSES from './../config/cancel-item-statuses';

const DIRECTIVE_NAME = TripItemCancellationMessage.DIRECTIVE_NAME = 'ktTripItemCancellationMessage';
export default function TripItemCancellationMessage() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripItemCancellationMessageController,
        controllerAs: 'tripItemCancellationMessageCtrl',
        scope: {
            cancellation: `=${DIRECTIVE_NAME}`,
        },
        link: function($scope, $elem, $attrs, tripItemCancellationMessageCtrl) {
            tripItemCancellationMessageCtrl.$onInit();
        },
    };
}

export function TripItemCancellationMessageController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,

        areTicketsCollected,

        isCancellationSucceeded,
        isCancellationFailed,
        isCancellationUnconfirmed,
        closeAlert,
    });

    function $onInit() {
    }

    function closeAlert() {
        vm.cancellation.cancellationStatus = null;
    }

    function isCancellationSucceeded() {
        return vm.cancellation.cancellationStatus
            && vm.cancellation.cancellationStatus.status === CANCEL_ITEM_STATUSES.SUCCESS;
    }

    function isCancellationFailed() {
        return vm.cancellation.cancellationStatus
            && vm.cancellation.cancellationStatus.status === CANCEL_ITEM_STATUSES.FAILED;
    }

    function isCancellationUnconfirmed() {
        return vm.cancellation.cancellationStatus
            && vm.cancellation.cancellationStatus.status === CANCEL_ITEM_STATUSES.UNCONFIRMED;
    }

    function areTicketsCollected() {
        return vm.cancellation.cancellationStatus
            && vm.cancellation.cancellationStatus.formData
            && vm.cancellation.cancellationStatus.formData.areTicketsCollected;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-cancellation-message/trip-item-cancellation-message-component.js